"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_STATE = void 0;
exports.clearError = clearError;
exports.default = reduceSession;
exports.setError = setError;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/toConsumableArray"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var actionTypes = _interopRequireWildcard(require("../actionTypes"));

var errorCounter = 0;
var DEFAULT_STATE = {
  // message: '',
  // status: null,
  hasError: false,
  errorArray: []
}; // Action Creators
// ---------------

exports.DEFAULT_STATE = DEFAULT_STATE;

function setError(error) {
  return {
    type: actionTypes.SET_ERROR,
    payload: {
      error: error
    }
  };
}

function clearError(error) {
  if (error) {
    return {
      type: actionTypes.CLEAR_ERROR,
      payload: {
        id: error.id
      }
    };
  }

  return null;
} // reducer


function reduceSession() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case actionTypes.SET_ERROR:
      {
        // check if there is same error already in the pipe,
        // in order to avoid displaying same message twise
        var index = state.errorArray.findIndex(function (error) {
          return error.status === action.payload.error.status;
        });

        if (index !== -1) {
          return (0, _objectSpread2.default)({}, state);
        } // it is a new error, add it to errorArray


        var newErrorArray = (0, _toConsumableArray2.default)(state.errorArray);
        newErrorArray.push({
          message: action.payload.error.message,
          status: action.payload.error.status,
          id: errorCounter
        });
        errorCounter += 1;
        return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, state), {}, {
          hasError: true,
          errorArray: newErrorArray
        });
      }

    case actionTypes.CLEAR_ERROR:
      {
        // remove error from errorArray
        var _newErrorArray = (0, _toConsumableArray2.default)(state.errorArray);

        var _index = _newErrorArray.findIndex(function (error) {
          return error.id === action.payload.id;
        });

        if (_index !== -1) {
          _newErrorArray.splice(_index, 1);
        }

        return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, state), {}, {
          errorArray: _newErrorArray,
          hasError: _newErrorArray.length > 0
        });
      }

    default:
      return state;
  }
}